import { Badge } from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import { capitalCase } from "change-case"
import { getSchoolMembershipRoleLabel } from "../membership/constants"
import Pathicon from "../pathicon/Pathicon"
import { usePathwrightContext } from "../pathwright/PathwrightContext"

type SchoolMembershipRoleBadgeProps = {
  role: number
}

function SchoolMembershipRoleBadge({ role }: SchoolMembershipRoleBadgeProps) {
  const { t } = useTranslate()
  const { school } = usePathwrightContext()
  const roleLabel = capitalCase(getSchoolMembershipRoleLabel(role, t))
  const tip = `${school.name} ${roleLabel}`

  return (
    <Tooltip title={tip} fitContent>
      <Badge colorPalette="brand" className="SchoolMembershipRoleBadge">
        <Pathicon icon="seal-check" />
        {roleLabel}
      </Badge>
    </Tooltip>
  )
}

export default SchoolMembershipRoleBadge
